import { ChevronDownIcon, ChevronRightIcon } from 'components/icons';
import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
	width: 100%;
	margin: 10px;
	background-color: white;
`;

const AccordionBody = styled.div`
	margin: 0 auto;
	background-color: #f4f3f3;
	height: 0;
	padding: 0 20px;
	box-sizing: border-box;
	transition: 0.5s;
`;

const Label = styled.label`
	cursor: pointer;
	background-color: white;
	color: grey;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
	display: block;
	margin-left: 5px;
	width: 100%;
	font-weight: 400;
	box-sizing: border-box;
	z-index: 100;
`;

const HiddenRadioButton = styled.input.attrs({ type: 'checkbox' })`
	display: none;
	&:checked + ${Label} {
		background-color: rgba(255, 255, 255, 0.15);
	}
	&:checked + ${Label}:before {
		transition: 0.5s;
	}
	&:checked ~ ${AccordionBody} {
		height: auto;
		font-size: 16px;
		padding: 20px;
		transition: 0.5s;
	}
`;

const Accordion = ({ children, name, idkey }) => {
	const [first, setfirst] = useState(false);
	return (
		<Container>
			<div>
				<HiddenRadioButton
					onClick={() => setfirst(state => !state)}
					name="acc"
					id={idkey}
				/>
				<Label htmlFor={idkey}>
					{name} &nbsp;<span style={{ color: 'black', fontSize: '10px' }}>
						{first ? <ChevronDownIcon /> : <ChevronRightIcon />}
					</span>
				</Label>
				<AccordionBody>{first && children}</AccordionBody>
			</div>
		</Container>
	);
};

export default Accordion;
